import MobileTabs from '@/components/molecules/MobileTabs'
import PageHeader from '@/components/organisms/PageHeader'
import ConfiguratorGrid from '@/components/templates/ConfiguratorGrid'
import Dialogs from '@/components/templates/Dialogs'
import useData from '@/hooks/useData'

export default function PageTemplate() {
  useData()

  return (
    <>
      <div className="relative m-auto flex w-full max-w-[140ch] flex-col gap-4 px-2 py-6 md:px-12 md:py-8 tablet:px-12 xl:px-0">
        <PageHeader />
        <MobileTabs />
        <ConfiguratorGrid />
      </div>
      <Dialogs />
    </>
  )
}
